export const PAID_TO_CREDITOR = "Creditor";
export const PAID_TO_CUSTOMER = "Customer";

export const PAID_TO_OPTIONS = [
  { value: PAID_TO_CREDITOR, title: "Direct to creditor" },
  { value: PAID_TO_CUSTOMER, title: "Cash to customer" },
];

export const TH_STYLE =
  "py-3.5 pl-3 pr-2 text-left text-sm font-semibold text-gray-900 border-b border-gray-200";

export const TD_STYLE =
  "whitespace-nowrap px-2 py-4 text-sm text-gray-600 align-top";
